import GravityCsvV1Adapter from 'teacher-ui-client/adapters/gravity/csv-v1-adapter'
import { join } from 'teacher-ui-client/utils/uri'
import type { Snapshot } from '@ember-data/legacy-compat/legacy-network-handler/snapshot'
import { assert } from '@ember/debug'

export default class RolloverImportValidationAdapter extends GravityCsvV1Adapter {
  urlForFindRecord(id: string, modelName: string, snapshot: Snapshot<unknown>) {
    const { host, namespace } = this
    const subscriptionType = snapshot?.adapterOptions?.subscriptionType
    assert('subscriptionType adapter option must be string', typeof subscriptionType === 'string')
    const pathForType = this.pathForType(modelName)
    return join(host, namespace, 'rollovers', subscriptionType, pathForType, id).href
  }

  pathForType(modelName: string) {
    return modelName === 'rollover-import-validation' ? 'validate' : super.pathForType(modelName)
  }
}
